/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthedShellRouteImport } from './routes/_authed/_shell'
import { Route as LoginCodeRouteImport } from './routes/login_.code'
import { Route as AuthedShellIndexRouteImport } from './routes/_authed/_shell/index'
import { Route as AuthedShellFriendsRouteImport } from './routes/_authed/_shell/friends'
import { Route as AuthedShellPlansRouteImport } from './routes/_authed/_shell/plans'
import { Route as AuthedShellSupportRouteImport } from './routes/_authed/_shell/support'
import { Route as AuthedShellICodeRouteImport } from './routes/_authed/_shell/i.$code'
import { Route as AuthedShellOrdersOrderIdRouteImport } from './routes/_authed/_shell/orders.$orderId'
import { Route as AuthedShellProfileIndexRouteImport } from './routes/_authed/_shell/profile.index'
import { Route as AuthedShellProfileHistoryRouteImport } from './routes/_authed/_shell/profile.history'
import { Route as AuthedShellProfileLoginMethodsRouteImport } from './routes/_authed/_shell/profile.login-methods'
import { Route as AuthedShellProfilePromosRouteImport } from './routes/_authed/_shell/profile.promos'

const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedShellRoute = AuthedShellRouteImport.update({
  id: '/_shell',
  getParentRoute: () => AuthedRoute,
} as any)
const LoginCodeRoute = LoginCodeRouteImport.update({
  id: '/login_/code',
  path: '/login/code',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedShellIndexRoute = AuthedShellIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedShellRoute,
} as any)
const AuthedShellFriendsRoute = AuthedShellFriendsRouteImport.update({
  id: '/friends',
  path: '/friends',
  getParentRoute: () => AuthedShellRoute,
} as any)
const AuthedShellPlansRoute = AuthedShellPlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => AuthedShellRoute,
} as any)
const AuthedShellSupportRoute = AuthedShellSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => AuthedShellRoute,
} as any)
const AuthedShellICodeRoute = AuthedShellICodeRouteImport.update({
  id: '/i/$code',
  path: '/i/$code',
  getParentRoute: () => AuthedShellRoute,
} as any)
const AuthedShellOrdersOrderIdRoute =
  AuthedShellOrdersOrderIdRouteImport.update({
    id: '/orders/$orderId',
    path: '/orders/$orderId',
    getParentRoute: () => AuthedShellRoute,
  } as any)
const AuthedShellProfileIndexRoute = AuthedShellProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => AuthedShellRoute,
} as any)
const AuthedShellProfileHistoryRoute =
  AuthedShellProfileHistoryRouteImport.update({
    id: '/profile/history',
    path: '/profile/history',
    getParentRoute: () => AuthedShellRoute,
  } as any)
const AuthedShellProfileLoginMethodsRoute =
  AuthedShellProfileLoginMethodsRouteImport.update({
    id: '/profile/login-methods',
    path: '/profile/login-methods',
    getParentRoute: () => AuthedShellRoute,
  } as any)
const AuthedShellProfilePromosRoute =
  AuthedShellProfilePromosRouteImport.update({
    id: '/profile/promos',
    path: '/profile/promos',
    getParentRoute: () => AuthedShellRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedShellIndexRoute
  '/login': typeof LoginRoute
  '/login/code': typeof LoginCodeRoute
  '/friends': typeof AuthedShellFriendsRoute
  '/plans': typeof AuthedShellPlansRoute
  '/support': typeof AuthedShellSupportRoute
  '/i/$code': typeof AuthedShellICodeRoute
  '/orders/$orderId': typeof AuthedShellOrdersOrderIdRoute
  '/profile/history': typeof AuthedShellProfileHistoryRoute
  '/profile/login-methods': typeof AuthedShellProfileLoginMethodsRoute
  '/profile/promos': typeof AuthedShellProfilePromosRoute
  '/profile/': typeof AuthedShellProfileIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthedShellIndexRoute
  '/login': typeof LoginRoute
  '/login/code': typeof LoginCodeRoute
  '/friends': typeof AuthedShellFriendsRoute
  '/plans': typeof AuthedShellPlansRoute
  '/support': typeof AuthedShellSupportRoute
  '/i/$code': typeof AuthedShellICodeRoute
  '/orders/$orderId': typeof AuthedShellOrdersOrderIdRoute
  '/profile/history': typeof AuthedShellProfileHistoryRoute
  '/profile/login-methods': typeof AuthedShellProfileLoginMethodsRoute
  '/profile/promos': typeof AuthedShellProfilePromosRoute
  '/profile': typeof AuthedShellProfileIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authed/_shell': typeof AuthedShellRouteWithChildren
  '/login_/code': typeof LoginCodeRoute
  '/_authed/_shell/friends': typeof AuthedShellFriendsRoute
  '/_authed/_shell/plans': typeof AuthedShellPlansRoute
  '/_authed/_shell/support': typeof AuthedShellSupportRoute
  '/_authed/_shell/': typeof AuthedShellIndexRoute
  '/_authed/_shell/i/$code': typeof AuthedShellICodeRoute
  '/_authed/_shell/orders/$orderId': typeof AuthedShellOrdersOrderIdRoute
  '/_authed/_shell/profile/history': typeof AuthedShellProfileHistoryRoute
  '/_authed/_shell/profile/login-methods': typeof AuthedShellProfileLoginMethodsRoute
  '/_authed/_shell/profile/promos': typeof AuthedShellProfilePromosRoute
  '/_authed/_shell/profile/': typeof AuthedShellProfileIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/login/code'
    | '/friends'
    | '/plans'
    | '/support'
    | '/i/$code'
    | '/orders/$orderId'
    | '/profile/history'
    | '/profile/login-methods'
    | '/profile/promos'
    | '/profile/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/login/code'
    | '/friends'
    | '/plans'
    | '/support'
    | '/i/$code'
    | '/orders/$orderId'
    | '/profile/history'
    | '/profile/login-methods'
    | '/profile/promos'
    | '/profile'
  id:
    | '__root__'
    | '/_authed'
    | '/login'
    | '/_authed/_shell'
    | '/login_/code'
    | '/_authed/_shell/friends'
    | '/_authed/_shell/plans'
    | '/_authed/_shell/support'
    | '/_authed/_shell/'
    | '/_authed/_shell/i/$code'
    | '/_authed/_shell/orders/$orderId'
    | '/_authed/_shell/profile/history'
    | '/_authed/_shell/profile/login-methods'
    | '/_authed/_shell/profile/promos'
    | '/_authed/_shell/profile/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  LoginRoute: typeof LoginRoute
  LoginCodeRoute: typeof LoginCodeRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/_shell': {
      id: '/_authed/_shell'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedShellRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/login_/code': {
      id: '/login_/code'
      path: '/login/code'
      fullPath: '/login/code'
      preLoaderRoute: typeof LoginCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/_shell/': {
      id: '/_authed/_shell/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedShellIndexRouteImport
      parentRoute: typeof AuthedShellRoute
    }
    '/_authed/_shell/friends': {
      id: '/_authed/_shell/friends'
      path: '/friends'
      fullPath: '/friends'
      preLoaderRoute: typeof AuthedShellFriendsRouteImport
      parentRoute: typeof AuthedShellRoute
    }
    '/_authed/_shell/plans': {
      id: '/_authed/_shell/plans'
      path: '/plans'
      fullPath: '/plans'
      preLoaderRoute: typeof AuthedShellPlansRouteImport
      parentRoute: typeof AuthedShellRoute
    }
    '/_authed/_shell/support': {
      id: '/_authed/_shell/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof AuthedShellSupportRouteImport
      parentRoute: typeof AuthedShellRoute
    }
    '/_authed/_shell/i/$code': {
      id: '/_authed/_shell/i/$code'
      path: '/i/$code'
      fullPath: '/i/$code'
      preLoaderRoute: typeof AuthedShellICodeRouteImport
      parentRoute: typeof AuthedShellRoute
    }
    '/_authed/_shell/orders/$orderId': {
      id: '/_authed/_shell/orders/$orderId'
      path: '/orders/$orderId'
      fullPath: '/orders/$orderId'
      preLoaderRoute: typeof AuthedShellOrdersOrderIdRouteImport
      parentRoute: typeof AuthedShellRoute
    }
    '/_authed/_shell/profile/': {
      id: '/_authed/_shell/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof AuthedShellProfileIndexRouteImport
      parentRoute: typeof AuthedShellRoute
    }
    '/_authed/_shell/profile/history': {
      id: '/_authed/_shell/profile/history'
      path: '/profile/history'
      fullPath: '/profile/history'
      preLoaderRoute: typeof AuthedShellProfileHistoryRouteImport
      parentRoute: typeof AuthedShellRoute
    }
    '/_authed/_shell/profile/login-methods': {
      id: '/_authed/_shell/profile/login-methods'
      path: '/profile/login-methods'
      fullPath: '/profile/login-methods'
      preLoaderRoute: typeof AuthedShellProfileLoginMethodsRouteImport
      parentRoute: typeof AuthedShellRoute
    }
    '/_authed/_shell/profile/promos': {
      id: '/_authed/_shell/profile/promos'
      path: '/profile/promos'
      fullPath: '/profile/promos'
      preLoaderRoute: typeof AuthedShellProfilePromosRouteImport
      parentRoute: typeof AuthedShellRoute
    }
  }
}

interface AuthedShellRouteChildren {
  AuthedShellFriendsRoute: typeof AuthedShellFriendsRoute
  AuthedShellPlansRoute: typeof AuthedShellPlansRoute
  AuthedShellSupportRoute: typeof AuthedShellSupportRoute
  AuthedShellIndexRoute: typeof AuthedShellIndexRoute
  AuthedShellICodeRoute: typeof AuthedShellICodeRoute
  AuthedShellOrdersOrderIdRoute: typeof AuthedShellOrdersOrderIdRoute
  AuthedShellProfileHistoryRoute: typeof AuthedShellProfileHistoryRoute
  AuthedShellProfileLoginMethodsRoute: typeof AuthedShellProfileLoginMethodsRoute
  AuthedShellProfilePromosRoute: typeof AuthedShellProfilePromosRoute
  AuthedShellProfileIndexRoute: typeof AuthedShellProfileIndexRoute
}

const AuthedShellRouteChildren: AuthedShellRouteChildren = {
  AuthedShellFriendsRoute: AuthedShellFriendsRoute,
  AuthedShellPlansRoute: AuthedShellPlansRoute,
  AuthedShellSupportRoute: AuthedShellSupportRoute,
  AuthedShellIndexRoute: AuthedShellIndexRoute,
  AuthedShellICodeRoute: AuthedShellICodeRoute,
  AuthedShellOrdersOrderIdRoute: AuthedShellOrdersOrderIdRoute,
  AuthedShellProfileHistoryRoute: AuthedShellProfileHistoryRoute,
  AuthedShellProfileLoginMethodsRoute: AuthedShellProfileLoginMethodsRoute,
  AuthedShellProfilePromosRoute: AuthedShellProfilePromosRoute,
  AuthedShellProfileIndexRoute: AuthedShellProfileIndexRoute,
}

const AuthedShellRouteWithChildren = AuthedShellRoute._addFileChildren(
  AuthedShellRouteChildren,
)

interface AuthedRouteChildren {
  AuthedShellRoute: typeof AuthedShellRouteWithChildren
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedShellRoute: AuthedShellRouteWithChildren,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRoute,
  LoginCodeRoute: LoginCodeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
